import {TranslocoService} from '@ngneat/transloco';
import {PropertiesErrorsInterface} from '../../shared/csv-validation/properties-errors.interface';

export class MeasurementPropertiesErrors implements PropertiesErrorsInterface {

  private measurementPropertiesErrors: { [key: string]: string };

  constructor(private readonly i18n: TranslocoService) {
    this.i18n.selectTranslation().subscribe(() => {
      this.measurementPropertiesErrors = {
        name: this.i18n.translate('info.importMeasurementsCsv.fields.name'),
        timestamp: this.i18n.translate('info.importMeasurementsCsv.fields.timestamp'),
        value: this.i18n.translate('info.importMeasurementsCsv.fields.value'),
        unit: this.i18n.translate('info.importMeasurementsCsv.fields.unit'),
        catalogInfo: this.i18n.translate('info.importMeasurementsCsv.fields.catalogInfo')
      }
    })
  }

  public getTranslation(property): string | null {
    return this.measurementPropertiesErrors.hasOwnProperty(property) ? this.measurementPropertiesErrors[property] : null;
  }
}

